var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header position-sticky"},[_c('bread-crumb')],1),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-md-12"},[_c('AllCards'),_c('BanksAccounts'),_c('MOMOAccounts')],1)]),_c('main-loader',{attrs:{"loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }